import React, { Component } from 'react';

import { useParams, useNavigate, Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import { apiUrl, mediaUrl} from'../Config/Config';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

//import { GET_CARLIST,GET_DELETECAR,GET_PRIORITYUPDATE } from '../../actions';


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
  
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      vehiclelist:'',
	  activePage: 1,
	  totalRecord: '',
	  search_all:'',
	  selectedStatus:'',
	  selectid:'',
    vehicleid:'',
    
    selectedFilOption:'',
    selectedFilvalue:'',
    actionType: '',
    title: '',
    };

   

    //this.props.getCarList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    }

   
   componentDidMount() {
      // document.title = PageTitle('Car List');
      // if(localStorage.getItem('admin_id') === null){
      // this.props.history.push('/');
      // }
	  this.listloadedData()
   }
   
    listloadedData(postobject='') {
  var qs = require('qs');
   if(postobject!=''){
    var postobject = postobject
   }else{
    var postobject = {
      activePage: this.state.activePage,
      search_all: '',
      admin_id: localStorage.getItem('admin_id')  
      };
   }
  
 axios.post(apiUrl+"vehicle/list",qs.stringify(postobject)).then(res => {
   
   if(res.data.status === 'success'){
	   console.log(res.data.vehiclelist,'-res.data')
       this.setState({vehiclelist: res.data, totalRecord: res.data.records_count}, function() {
         this.vehiclelist();
       });
   }else{
    this.setState({  vehiclelist: '', totalRecord: 0}, function() {
      this.vehiclelist();
    });
   }
 }); 
}

    handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
	  this.listloadedData(postobject);
     // this.props.getCarList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    var postObject = {             
      activePage   : this.state.activePage,
      search_all : value,
      admin_id: localStorage.getItem('admin_id')           
    };
    this.listloadedData(postObject)
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
         
           var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
            activePage   : 1,
            search_all : this.state.search_all,
            filterVal : this.state.selectedFilvalue,
            admin_id: admin_id         
          };
		  this.listloadedData(postObject);
          //console.log(postObject);
        //  this.props.getCarList(qs.stringify(postObject));
        
    } 

  
   
   handleChange = (name,carid,event) => {
	  this.setState({priorityid: name,priorityvalue: event.target.value})
	   var qs = require('qs');
			var postObject = {
			  value :event.target.value,
			  vehicle_id  :carid
		};
	 // this.props.getPriorityUpdate(qs.stringify(postObject));

	}

	deletevehicle(id){
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          vehicle_id  :id
        };
      //this.props.getDeleteCar(qs.stringify(postObject));
      this.setState({vehicleid : id})
      $('.confirm-action-delete-message').html('Are you sure! you want to delete the vehicle?');	
      $('.confirm-action-delete').addClass('show');	
	}

  vehiclelist() {
	 // console.log(this.state.vehiclelist,'vehiclelist')
    var vehiclelist = this.state.vehiclelist;
    if (vehiclelist != "undefined" && vehiclelist != null) {
      if (vehiclelist.status == "success") {
        if (Object.keys(vehiclelist).length > 0) {
          const vehiclelistDetails = vehiclelist.vehiclelist.map(
            (vehiclelist, Index) => {
              let sno = Index+1;
              if(vehiclelist.vehicle_status == 'A'){
                var status = 'Active';
              }else{
                var status = 'Inactive';
              }
			  
			  var inputpriname  = "priority_"+vehiclelist.vehicle_id;
              var privalue = '';
              if(this.state.priorityid !== inputpriname){
                 privalue = vehiclelist.priority;
              }else{
                 privalue = this.state.priorityvalue;
              }
			  var istyle = { width: 100};
              return (
                <tr key={vehiclelist.vehicle_id}>
                <td>{sno}</td>
                  <td><img src={mediaUrl+'/cars/'+vehiclelist.vehicle_image}  width="100px" height="100px" style={{maxHeight:"70px"}}/></td>
                  <td>{vehiclelist.map_icon_img!=null && vehiclelist.map_icon_img!='' &&(
                    <img src={mediaUrl+'/cars/'+vehiclelist.map_icon_img}  width="100px" height="100px" style={{maxHeight:"70px"}}/>
                  )}</td>
                  <td>
                      {vehiclelist.vehicle_name} {vehiclelist.vehicle_model ? ` - ${vehiclelist.vehicle_model}` : ''}                  </td>
                  {/* <td>{vehiclelist.vehicle_model}</td> */}
				          <td style={istyle}><input type="text" name={inputpriname} value={privalue} onChange={this.handleChange.bind(this,inputpriname,vehiclelist.vehicle_id)}/></td>
                   <td>{status}</td>
                  <td className="actiongroup">

                    {status === 'Active' ? (
                      <Link onClick={() => this.confirmPopup(vehiclelist.vehicle_id, 'Inactive', vehiclelist.vehicle_name)} title="Active">
                        <i className="ft-unlock" aria-hidden="true"></i>
                      </Link>
                    ) : (
                      <Link onClick={() => this.confirmPopup(vehiclelist.vehicle_id, 'Active', vehiclelist.vehicle_name)} title="In Active">
                        <i className="ft-lock" aria-hidden="true"></i>
                      </Link>
                    )}
                    <Link to={{ pathname: '/vehicle-edit/'+vehiclelist.vehicle_id}} className="" title="Edit">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                     <Link onClick={this.deletevehicle.bind(this,vehiclelist.vehicle_id)} className="" title="Delete">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return vehiclelistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="7" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }

   confirmPopup = (id, actionType, title) => {     
        this.setState({ selectid: id, actionType});
        $(".confirm-action").addClass("show");
    };

    
    Confirmstatus = (confirmstatus) => {
      if (confirmstatus === 'yes') {
        if (this.state.actionType === 'Inactive' || this.state.actionType === 'Active') {
          this.changeStatus(this.state.selectid);
        }
      }
      $('.confirm-action').removeClass('show');
    };

    changeStatus(id = null){
        
      let stat = ''
      if(this.state.actionType ==='Inactive'){
        stat = "I";
      } 
      else if(this.state.actionType ==='Active'){
        stat = "A";
      }  
      var qs = require('qs');
      var postObject = {
        admin_id : localStorage.getItem("admin_id"),
        id  : this.state.selectid,
        status: stat
      };
      axios.post(apiUrl+"vehicle/changestatus", qs.stringify(postObject)).then(res => {
        if(res.data.status == "success"){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
            this.listloadedData()
            setTimeout(
            function() {
              $('.success_message').html('');
            }
            .bind(this),
            3000
            );
        }else{
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(
            function() {
              $('.success_message').html('');
            }
          .bind(this), 3000);
        }
      });
    }

  deleteConfirm =(confirmstatus,vehicle_id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      var qs = require('qs');       
      var postObject = { 
        column: 'vehicle_id',         
        value: vehicle_id,   
        activePage:this.state.activePage,  
        admin_id:localStorage.getItem("admin_id")
      };
      axios.post(apiUrl+"vehicle/delete",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(
          function() {
          $('.success_message').html('');
          }
          .bind(this),
          3000
          );

          this.listloadedData()
       
        }
      });  
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
  }
  handleFilChange = (selOption) => {       	
    this.setState({selectedFilOption:selOption})
    this.setState({  selectedFilvalue : selOption.value},function(){
      this.handleFormSubmit()
    });
  };
  
  render() {
    return (
      <div className="wrapper"> 
        <div className="confirm-action">
          <p>Are you sure! you want to {this.state.actionType} the vehicle?</p>
          <a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
          <a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
        </div>
 
    <Header />
    <MenuSidebar currentpage="vehicle"  currentTab="car" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">
              <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.totalRecord} Vehicle{this.state.totalRecord>1 ? 's' : ''}</h3>
                </div>
                <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-100'>
                  <div className="search-list">
                    <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="input_search">
                          <div className="search-inner search_input">
                            <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                            <button className="" type="submit">Submit</button>
                            <div className="erroremail"></div>
                          </div>
                          <div className="search-inner search_select">
                          <Select name="category" options={lang.common.status_filter_option} 
                            //onChange={this.handleInputChange}
                            onChange={this.handleFilChange.bind(this)}
                          />
                        </div>  
                    </div>
                  </form>
                  </div>
                  <div className="add_button">  
                      <a className="primary-btn" href='/vehicle-add'>Add</a> 
                  </div>  
                </div>  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Image</th>
                      <th>Map Icon</th>
                      <th>Vehicle Name/Model</th>
					            <th>Priority</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.vehiclelist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
      <div className="confirm-action-delete">
          <p className="confirm-action-delete-message"></p>
          
          
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.vehicleid)} className="btn">Yes</a>
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
          <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
        </div>
    </div>
    );
  }
}

export default withRouter(List);
/*
const mapStateTopProps = (state) => {
  return {
    carlist: state.carlist,
    deletecar: state.deletecar,
	  priorityupdate: state.priorityupdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCarList: (formVal) =>{
       dispatch({ type: GET_CARLIST, formVal});
    },
    getDeleteCar: (formPayload) =>{
      dispatch({ type: GET_DELETECAR, formPayload });
    },	
	getPriorityUpdate: (formPayload) =>{
      dispatch({ type: GET_PRIORITYUPDATE, formPayload });
    }
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));*/